import { render, staticRenderFns } from "./imgStyle.vue?vue&type=template&id=39044911&scoped=true"
import script from "./imgStyle.vue?vue&type=script&lang=js"
export * from "./imgStyle.vue?vue&type=script&lang=js"
import style0 from "./imgStyle.vue?vue&type=style&index=0&id=39044911&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39044911",
  null
  
)

export default component.exports